import introImg from '../../../../assets/images/courses/teamplayer&collaboration/chapter1.1.jpg';
import chapterImg1 from '../../../../assets/images/courses/teamplayer&collaboration/chapter1.2.jpg';
import { CourseChapter } from '../../../../courses/courses.types';
import { MediaBlock } from '../../MediaBlock';

interface TeamPlayersAndCollaborationChapter1 {
  chapter: CourseChapter;
  onNextChapter: (nextIndex: number) => void;
  totalPages: number;
  courseId?: string;
  onQuizResult?: (result: boolean | undefined) => void;
}

export const TeamPlayersAndCollaborationChapter1: React.FC<TeamPlayersAndCollaborationChapter1> = ({
  chapter,
  onNextChapter,
  totalPages,
}) => {
  const handleNextChapterClick = () => {
    onNextChapter(chapter.index + 1);
  };

  return (
    <>
      <div className="content-wrap lg:border-l lg:pl-8 lg:pt-8 pt-4 pb-10">
        <p className="text-sm italic  mb-7">
          Part {chapter.index} of {totalPages}
        </p>
        <h2 className="font-semibold text-3xl">Overview</h2>

        <MediaBlock mediaImage={introImg}></MediaBlock>
        <br />
        <h3 className="text-2xl text-purple-600 font-bold mb-1">Introduction</h3>

        <p className="text-lg font-bold text-center mt-7 mb-20 leading-10">
          Being a valuable team player is an important skill, even if it’s not the first thing that
          comes to mind when you think about career success.
        </p>
        <div className="md:flex items-center mb-7">
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg1} alt="" />
          </div>
          <p className="flex-1 leading-7">
            <br />
            This module will show you how to be an awesome teammate and improve your skills while
            working in groups. You'll learn how to communicate better, build strong relationships,
            and earn your teammates' trust. This module covers creating a positive team culture,
            handling conflicts, and making everyone feel safe to share their ideas. You'll also pick
            up strategies to think strategically, which will help you and your team solve problems
            more effectively.
          </p>
        </div>

        <h3 className="text-2xl text-purple-600 font-bold mb-1">Learning Objectives</h3>
        <p className="text-xl font-light mb-8">
          Upon completion of this lesson, you will be able to:
        </p>
        <ul className="list-disc pl-5 mb-14 text-xl font-light">
          <li className="pl-9 mb-7">
            Build trusted relationships by being fully engaged and clear about expectations.
          </li>
          <li className="pl-9 mb-7">
            Create a safe environment where everyone feels comfortable sharing ideas.
          </li>
          <li className="pl-9 mb-7">
            Develop a positive team culture that encourages respect and cooperation.
          </li>
          <li className="pl-9 mb-7">
            Think strategically to help solve problems and make better decisions.
          </li>
          <li className="pl-9 mb-7">Handle conflicts in a confident and constructive way.</li>
          <li className="pl-9 mb-7">
            Avoid common teamwork problems like groupthink and risky decisions.
          </li>
          <li className="pl-9 mb-7">
            Take steps to keep improving your teamwork and collaboration skills.{' '}
          </li>
        </ul>

        <h3 className="text-2xl mt-2  text-center font-light mb-5">
          Let's start with cultivating trusted relationships
        </h3>
        <button onClick={handleNextChapterClick} className="btn-internal w-full">
          Cultivate Trusted Relationships
        </button>
      </div>
    </>
  );
};
